import React from "react";
import { HiOutlineWallet } from "react-icons/hi2";
import { FaBtc } from "react-icons/fa";
import { SiTether, SiBinance } from "react-icons/si";
import { FaEthereum } from "react-icons/fa";
import { FiThumbsUp } from "react-icons/fi";
import "./index.scss";

export default function Dashboard() {
  return (
    <div className="gridCard">
      <div>
        <div className="flexCard">
          <HiOutlineWallet size={40} />
          <h2 className="h2Div">Wallet Cryptocurrency</h2>
        </div>

        <div
          className="assetDiv"
          style={{
            backgroundImage: 'url("./assets/balance-bg.png")',
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right",
          }}
        >
          <p
            style={{
              color: "rgb(156 163 175)",
              fontWeight: 600,
              fontSize: "0.775rem",
              // lineHeight: "1.25rem",
            }}
          >
            Total assets
          </p>
          <p
            style={{
              fontWeight: 600,
              fontSize: "1.2rem",
            }}
          >
            2,460.89
            <span
              style={{
                color: "rgb(156 163 175)",
                fontWeight: 400,
                fontSize: "0.875rem",
                marginLeft: "0.5rem",
              }}
            >
              USD
            </span>
          </p>
          <p style={{ color: "white", fontWeight: 400, fontSize: "0.875rem" }}>
            0.23415600
            <span
              style={{
                color: "rgb(156 163 175)",
                marginLeft: "0.5rem",
              }}
            >
              BTC
            </span>
          </p>
        </div>

        <div className="coinsDiv">
          <li className="coinLi">
            <div style={{ display: "flex", gap: "1.25rem" }}>
              <div className="btcDiv">
                <FaBtc fill="#f7931a" style={{ width: "2rem" }} size={40} />
              </div>
              <div style={{ padding: "0px" }}>
                <p style={{ color: "white", fontWeight: 600, fontSize: "1.0rem" }}>Bitcoin</p>
                <span
                  style={{ color: "rgb(107 114 128)", fontSize: "0.875rem", lineHeight: "1.25rem", fontWeight: 600 }}
                >
                  BTC
                </span>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", margin: 0 }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p style={{ color: "white", marginTop: "0px", fontWeight: 600 }}>0.1832</p>
                <span
                  style={{ color: "rgb(107 114 128)", fontSize: "0.875rem", lineHeight: "1.25rem", fontWeight: 600 }}
                >
                  123.23 USD
                </span>
              </div>
            </div>
          </li>
          <li className="coinLi">
            <div style={{ display: "flex", gap: "1.25rem", margin: 0 }}>
              <div className="btcDiv">
                <SiTether fill="green" style={{ width: "2rem" }} size={40} />
              </div>
              <div style={{ padding: "0px" }}>
                <p style={{ color: "white", fontWeight: 600 }}>Tether</p>
                <span
                  style={{ color: "rgb(107 114 128)", fontSize: "0.875rem", lineHeight: "1.25rem", fontWeight: 600 }}
                >
                  USDT
                </span>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", margin: 0 }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p style={{ color: "white", marginTop: "0px", fontWeight: 600 }}>0.1832</p>
                <span
                  style={{ color: "rgb(107 114 128)", fontSize: "0.875rem", lineHeight: "1.25rem", fontWeight: 600 }}
                >
                  123.23 USD
                </span>
              </div>
            </div>
          </li>
          <li className="coinLiLast">
            <div style={{ display: "flex", gap: "1.25rem", margin: 0 }}>
              <div className="btcDiv">
                <FaEthereum fill="white" style={{ width: "2rem" }} size={40} />
              </div>
              <div style={{ padding: "0px" }}>
                <p style={{ color: "white", fontWeight: 600 }}>Ethereum</p>
                <span
                  style={{ color: "rgb(107 114 128)", fontSize: "0.875rem", lineHeight: "1.25rem", fontWeight: 600 }}
                >
                  ETH
                </span>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", margin: 0 }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p style={{ color: "white", marginTop: "0px", fontWeight: 600 }}>0.1832</p>
                <span
                  style={{ color: "rgb(107 114 128)", fontSize: "0.875rem", lineHeight: "1.25rem", fontWeight: 600 }}
                >
                  123.23 USD
                </span>
              </div>
            </div>
          </li>
        </div>
      </div>

      <div>
        <div className="flexCard">
          <FiThumbsUp size={40} />
          <h2 className="h2Div">Top Tokens</h2>
        </div>

        <div className="coinsDiv">
          <ul style={{ paddingLeft: "1.25rem", paddingRight: "1.25rem", paddingTop: "2rem", paddingBottom: "2rem" }}>
            <li className="topCoinsLi">
              <div style={{ display: "flex", gap: "0.75rem" }}>
                <div className="coinDiv">
                  <FaBtc fill="#f7931a" style={{ width: "3rem" }} size={40} />
                </div>
                <div style={{ alignSelf: "center" }}>
                  <p style={{ color: "white", fontWeight: 600, marginBottom: "2px", marginTop: 0 }}>Bitcoin</p>
                  <span
                    style={{ color: "rgb(107 114 128)", fontSize: "0.875rem", lineHeight: "1.25rem", fontWeight: 600 }}
                  >
                    BTC
                  </span>
                </div>
              </div>
              <div style={{ display: "flex", gap: "0.75rem" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ fontWeight: 600 }}>$24024</p>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="spanDiv">1.76%</span>
                </div>
              </div>
            </li>
            <li className="topCoinsLi" style={{ marginTop: "1.25rem" }}>
              <div style={{ display: "flex", gap: "0.75rem" }}>
                <div className="coinDiv">
                  <FaEthereum fill="#8c8c8c" style={{ width: "3rem" }} size={40} />
                </div>
                <div style={{ alignSelf: "center" }}>
                  <p style={{ color: "white", fontWeight: 600, marginBottom: "2px", marginTop: 0 }}>Ethereum</p>
                  <span
                    style={{ color: "rgb(107 114 128)", fontSize: "0.875rem", lineHeight: "1.25rem", fontWeight: 600 }}
                  >
                    ETH
                  </span>
                </div>
              </div>
              <div style={{ display: "flex", gap: "0.75rem" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ fontWeight: 600 }}>$24024</p>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="spanDiv">1.76%</span>
                </div>
              </div>
            </li>
            <li className="topCoinsLi" style={{ marginTop: "1.25rem" }}>
              <div style={{ display: "flex", gap: "0.75rem" }}>
                <div className="coinDiv">
                  <SiBinance fill="yellow" style={{ width: "3rem" }} size={40} />
                </div>
                <div style={{ alignSelf: "center" }}>
                  <p style={{ color: "white", fontWeight: 600, marginBottom: "2px", marginTop: 0 }}>Binance Coin</p>
                  <span
                    style={{ color: "rgb(107 114 128)", fontSize: "0.875rem", lineHeight: "1.25rem", fontWeight: 600 }}
                  >
                    BNB
                  </span>
                </div>
              </div>
              <div style={{ display: "flex", gap: "0.75rem" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ fontWeight: 600 }}>$24024</p>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="spanDiv">1.76%</span>
                </div>
              </div>
            </li>
            <li className="topCoinsLi" style={{ marginTop: "1.25rem" }}>
              <div style={{ display: "flex", gap: "0.75rem" }}>
                <div className="coinDiv">
                  <SiTether fill="green" style={{ width: "3rem" }} size={40} />
                </div>
                <div style={{ alignSelf: "center" }}>
                  <p style={{ color: "white", fontWeight: 600, marginBottom: "2px", marginTop: 0 }}>Tether</p>
                  <span
                    style={{ color: "rgb(107 114 128)", fontSize: "0.875rem", lineHeight: "1.25rem", fontWeight: 600 }}
                  >
                    USDT
                  </span>
                </div>
              </div>
              <div style={{ display: "flex", gap: "0.75rem" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ fontWeight: 600 }}>$24024</p>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="spanDiv">1.76%</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {/* <div>
        <div className="flex items-center border-b pb-5 border-[#3b3b3b]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            // stroke-width="1.5"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              // stroke-linecap="round"
              // stroke-linejoin="round"
              d="M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904M14.25 9h2.25M5.904 18.75c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 01-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 10.203 4.167 9.75 5 9.75h1.053c.472 0 .745.556.5.96a8.958 8.958 0 00-1.302 4.665c0 1.194.232 2.333.654 3.375z"
            />
          </svg>
          <h2 className="ml-2 font-medium">Stake STONE</h2>
        </div>

        <div className="rounded-xl bg-gradient-to-br from-[#0a0a0a] to-[#161617] border-[#2d2d2d] border mt-5 p-5">
          <div className="flex justify-between">
            <p className="text-white text-sm">Balance:</p>
            <p className="text-gray-500 text-sm">0 STONE</p>
          </div>

          <input type="text" className="text-white bg-transparent border-[#2d2d2d] border w-full mt-5 rounded-xl" />

          <div className="flex">
            <button className="bg-[#393a3e] py-4 px-10 rounded-xl mx-auto text-sm mt-5 uppercase font-semibold hover:bg-[#424347]">
              Approve
            </button>
          </div>

          <div className="flex justify-between mt-10">
            <p className="text-white text-sm">dStone Balance:</p>
            <p className="text-gray-500 text-sm">0 dStone</p>
          </div>

          <div className="relative">
            <input type="text" className="text-white bg-transparent border-[#2d2d2d] border w-full mt-5 rounded-xl" />
            <button className="absolute right-3 top-[30px] rounded-xl px-5 border-[#2d2d2d] py-2 border font-semibold text-sm">
              MAX
            </button>
          </div>

          <div className="flex">
            <button className="bg-[#393a3e] py-4 px-10 rounded-xl mx-auto text-sm mt-5 uppercase font-semibold hover:bg-[#424347]">
              Withdraw
            </button>
          </div>
        </div>
      </div> */}
    </div>
  );
}
